module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_credit_card.2929c9089391bdf53ba13e1b1052e4b6.png";